import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'

const initialState = {
    employeeList: { employees: [], total: 0, pageSize: 0, error: null, loading: false },
    activeEmployee: { employee: null, error: null, loading: false },
    newEmployee: { employee: null, error: null, loading: false },
    updateEmployee: { employee: null, error: null, loading: false },
    updateState: { success: false, error: null, loading: false },
    deleteEmployee: { employee: null, error: null, loading: false },
    uploadPhoto: { photoUrl: null, error: null, loading: false },
    deletePhoto: { success: false, error: null, loading: false },
    employeeSellList: { sells: [], total: 0, totalSold: 0, pageSize: 0, error: null, loading: false },
    employeeSellItemList: { items: [], total: 0, pageSize: 0, error: null, loading: false },
    employeeByStoreList: { employees: [], error: null, loading: false },
}

export default (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.FETCH_EMPLOYEES:
            return {
                ...state,
                employeeList: {
                    ...state.employeeList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_EMPLOYEES_SUCCESS:
            return {
                ...state,
                employeeList: {
                    employees: action.payload.employees,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_EMPLOYEES_FAILURE:
            return {
                ...state,
                employeeList: {
                    employees: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_EMPLOYEES:
            return { ...state, employeeList: initialState.employeeList }



        case actionTypes.FETCH_EMPLOYEE:
            return { ...state, activeEmployee: { employee: null, error: null, loading: true } }

        case actionTypes.FETCH_EMPLOYEE_SUCCESS:
            return { ...state, activeEmployee: { employee: action.payload.employee, error: null, loading: false } }

        case actionTypes.FETCH_EMPLOYEE_FAILURE:
            return { ...state, activeEmployee: { employee: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_EMPLOYEE:
            return { ...state, activeEmployee: initialState.activeEmployee }



        case actionTypes.CREATE_EMPLOYEE:
            return {
                ...state,
                newEmployee: {
                    employee: null,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.CREATE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                newEmployee: {
                    employee: action.payload.employee,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.CREATE_EMPLOYEE_FAILURE:
            return {
                ...state,
                newEmployee: {
                    employee: null,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_CREATE_EMPLOYEE:
            return { ...state, newEmployee: initialState.newEmployee }




        case actionTypes.UPDATE_EMPLOYEE:
            return { ...state, updateEmployee: { employee: null, error: null, loading: true } }

        case actionTypes.UPDATE_EMPLOYEE_SUCCESS:
            return { ...state, updateEmployee: { employee: action.payload.employee, error: null, loading: false } }

        case actionTypes.UPDATE_EMPLOYEE_FAILURE:
            return { ...state, updateEmployee: { employee: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPDATE_EMPLOYEE:
            return { ...state, updateEmployee: initialState.updateEmployee }


        case actionTypes.UPDATE_EMPLOYEE_STATE:
            return { ...state, updateState: { success: false, error: null, loading: true } }

        case actionTypes.UPDATE_EMPLOYEE_STATE_SUCCESS:
            return { ...state, updateState: { success: true, error: null, loading: false } }

        case actionTypes.UPDATE_EMPLOYEE_STATE_FAILURE:
            return { ...state, updateState: { success: false, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPDATE_EMPLOYEE_STATE:
            return { ...state, updateState: initialState.updateState }


        case actionTypes.DELETE_EMPLOYEE:
            return { ...state, deleteEmployee: { employee: null, error: null, loading: true } }

        case actionTypes.DELETE_EMPLOYEE_SUCCESS:
            return { ...state, deleteEmployee: { employee: action.payload.employee, error: null, loading: false } }

        case actionTypes.DELETE_EMPLOYEE_FAILURE:
            return { ...state, deleteEmployee: { employee: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_EMPLOYEE:
            return { ...state, deleteEmployee: initialState.deleteEmployee }



        case actionTypes.UPLOAD_EMPLOYEE_PHOTO:
            return { ...state, uploadPhoto: { photoUrl: null, error: null, loading: true } }

        case actionTypes.UPLOAD_EMPLOYEE_PHOTO_SUCCESS:
            return { ...state, uploadPhoto: { photoUrl: action.payload.photoUrl, error: null, loading: false } }

        case actionTypes.UPLOAD_EMPLOYEE_PHOTO_FAILURE:
            return { ...state, uploadPhoto: { photoUrl: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPLOAD_EMPLOYEE_PHOTO:
            return { ...state, uploadPhoto: initialState.uploadPhoto }



        case actionTypes.DELETE_EMPLOYEE_PHOTO:
            return { ...state, deletePhoto: { success: false, error: null, loading: true } }

        case actionTypes.DELETE_EMPLOYEE_PHOTO_SUCCESS:
            return { ...state, deletePhoto: { success: true, error: null, loading: false } }

        case actionTypes.DELETE_EMPLOYEE_PHOTO_FAILURE:
            return { ...state, deletePhoto: { success: false, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_EMPLOYEE_PHOTO:
            return { ...state, deletePhoto: initialState.deletePhoto }



        case actionTypes.FETCH_EMPLOYEE_SELLS:
            return {
                ...state,
                employeeSellList: {
                    ...state.employeeSellList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_EMPLOYEE_SELLS_SUCCESS:
            return {
                ...state,
                employeeSellList: {
                    sells: action.payload.sells,
                    total: action.payload.total,
                    totalSold: action.payload.totalSold,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_EMPLOYEE_SELLS_FAILURE:
            return {
                ...state,
                employeeSellList: {
                    sells: [],
                    total: 0,
                    pageSize: 0,
                    totalSol: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_EMPLOYEE_SELLS:
            return { ...state, employeeSellList: initialState.employeeSellList }

        case actionTypes.FETCH_EMPLOYEE_SELLS_ITEMS:
            return {
                ...state,
                employeeSellItemList: {
                    ...state.employeeSellItemList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_EMPLOYEE_SELLS_ITEMS_SUCCESS:
            return {
                ...state,
                employeeSellItemList: {
                    items: action.payload.items,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_EMPLOYEE_SELLS_ITEMS_FAILURE:
            return {
                ...state,
                employeeSellItemList: {
                    items: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_EMPLOYEE_SELLS_ITEMS:
            return { ...state, employeeSellItemList: initialState.employeeSellItemList }



        case actionTypes.FETCH_EMPLOYEES_BY_STORE:
            return {
                ...state,
                employeeByStoreList: {
                    ...state.employeeByStoreList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_EMPLOYEES_BY_STORE_SUCCESS:
            return {
                ...state,
                employeeByStoreList: {
                    employees: action.payload.employees,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_EMPLOYEES_BY_STORE_FAILURE:
            return {
                ...state,
                employeeByStoreList: {
                    employees: [],
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_EMPLOYEES_BY_STORE:
            return { ...state, employeeByStoreList: initialState.employeeByStoreList }

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/employee/reducer.js